import AuthContainer from './ui/AuthContainer'
import './i18n'

export default AuthContainer